<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-h3 text-center">{{ displayTime }}</div>
      </v-col>
    </v-row>
    <v-row align="center" justify="space-between">
      <v-col cols="8">
        <v-btn
          class="white--text"
          :color="buttonColor"
          rounded
          @click="toggleClock"
          >{{ buttonText }}</v-btn
        >
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn
              small
              rounded
              color="grey"
              class="ml-3 white--text"
              @click="saveClock"
              >Save</v-btn
            ></v-col
          >
          <v-col cols="6">
            <v-btn
              small
              rounded
              color="grey"
              class="ml-3 white--text"
              @click="resetClock"
              >Reset</v-btn
            ></v-col
          >
        </v-row>
      </v-col>
    </v-row>
    <!--
    <v-row justify="space-between">
      <v-col cols="4">
        <v-btn
          color="blue"
          rounded
          class="ml-3 white--text"
          @click="completeClock"
          >Complete</v-btn
        >
      </v-col>
      <v-col cols="4">
        <v-btn
          x-small
          rounded
          color="grey"
          class="ml-3 white--text"
          @click="resetClock"
          >Reset</v-btn
        ></v-col
      >
    </v-row>-->
  </v-container>
</template>

<script>
export default {
  name: "Clock",
  data: function () {
    return {
      interval: null,
      lastCall: null,
      elapsedTime: 0,
    };
  },
  props: {
    duration: {
      type: Number,
      required: false,
    },
    autostart: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    countdown: function () {
      return this.duration ? true : false;
    },
    displayTime: function () {
      var time = this.countdown
        ? this.duration - this.elapsedTime
        : this.elapsedTime;
      if (time < 0) return "-" + this.millisecondsToDisplay(-1 * time);
      else return this.millisecondsToDisplay(time);
    },
    buttonColor: function () {
      if (this.interval) {
        return "red";
      } else {
        return "green";
      }
    },
    buttonText: function () {
      if (this.interval) {
        return "Stop";
      } else {
        return "Start";
      }
    },
  },
  watch: {
    duration: function () {
      if (this.autostart) {
        this.startClock();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    if (this.autostart) {
      this.startClock();
    }
  },
  methods: {
    millisecondsToDisplay: function (time) {
      // Pad to 2 or 3 digits, default is 2
      function pad(n, z) {
        z = z || 2;
        return ("00" + n).slice(-z);
      }

      var ms = time % 1000;
      time = (time - ms) / 1000;
      var secs = time % 60;
      time = (time - secs) / 60;
      var mins = time % 60;
      var hrs = (time - mins) / 60;

      var result = "";
      if (hrs > 0) {
        result +=
          hrs +
          ":" +
          pad(mins) +
          ":" +
          pad(secs) +
          "." +
          pad(ms, 3).slice(0, 2);
      } else if (mins > 0) {
        result += mins + ":" + pad(secs) + "." + pad(ms, 3).slice(0, 2);
      } else if (secs > 0) {
        result += secs + "." + pad(ms, 3).slice(0, 2);
      } else {
        result += secs + "." + pad(ms, 3).slice(0, 2);
      }

      return result;
    },
    resetClock: function () {
      clearInterval(this.interval);
      this.interval = null;
      this.elapsedTime = 0;
    },
    toggleClock: function () {
      if (this.interval) {
        this.stopClock();
      } else {
        this.startClock();
      }
    },
    startClock: function () {
      if (!this.interval) {
        this.lastCall = new Date().getTime();
        this.interval = setInterval(() => {
          const now = new Date().getTime();
          this.elapsedTime += now - this.lastCall;
          this.lastCall = now;

          if (this.countdown && this.elapsedTime >= this.duration) {
            this.$emit("complete");
          }
        }, 20);
      }
    },
    stopClock: function () {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    saveClock: function () {
      clearInterval(this.interval);
      this.interval = null;
      this.$emit("save", this.displayTime);
    },
    completeClock: function () {
      clearInterval(this.interval);
      this.interval = null;
      this.$emit("complete");
    },
  },
};
</script>
